import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { AssignmentContext } from '../providers/AssignmentsProvider/index';
import { UseAssignments } from '../providers/AssignmentsProvider/types';

const useAssignments = (): UseAssignments => {
  const [state, dispatch] = useContextWithErrorHandler(AssignmentContext, 'AssignmentProvider');

  return [state, dispatch];
};

export default useAssignments;
